export default __webpack_public_path__ + "static/media/game-graphics.d458aa8d.jpg";